import * as nsVue from 'vue'
import { Vue, Component, Inject, Model, Prop, Watch } from 'vue-property-decorator'
import * as api from "../api";
import { tree, cc } from "../utils";
import { Item, InputRow, Node } from "../models";
import FormRows from "../parts/FormRows";
import Tab from "../parts/Tab"
import format from '../format'
import App from '../App'
import { shuffle } from '../utils'
import SelectNode, { SelectNodeResult } from '../parts/SelectNode'
import { remoteOp } from "../helper";

declare const Sortable: any

const confirmMsg = '排序已修改, 是否放弃保存?'

interface UnsetState {
  kind: 'unset';
}

interface ErrorState {
  kind: 'error';
  message: string;
}

interface DoneState {
  kind: 'done';
  node: Node;
  selected: number[];
  sorting: {
    indices: number[];
    modified: boolean;
    key: string | null;
    ast: boolean;
  } | null;
}

type State = UnsetState | ErrorState | DoneState

@Component({
  name: 'PortalNodeList',
  components: { Tab },

  filters: {
    attrs(node: Node) {
      let str = ''
      if (node.alias)
        str += '#' + node.alias
      if (node.class_list)
        str += '.' + node.class_list.replace(/ /g, '.')
      return str
    }
  },

  beforeRouteUpdate(this: PortalNodeList, to, from, next) {
    let shouldNext = true
    if (this.modified) {
      shouldNext = confirm(confirmMsg)
    }
    next(shouldNext ? undefined : false)
  },

  beforeRouteLeave(this: PortalNodeList, to, from, next) {
    let shouldNext = true
    if (this.modified) {
      shouldNext = confirm(confirmMsg)
    }
    next(shouldNext ? undefined : false)
  }
})
export default class PortalNodeList extends Vue {
  @Prop() root: Node

  nodeId = 0

  state: State = {kind: 'unset'}

  busy = false

  private _sortable: any

  formSelectNode = SelectNode

  get status() {
    return this.state.kind
  }

  get modified() {
    return this.state.kind === 'done'
        && this.state.sorting
        && this.state.sorting.modified
  }

  get items(): ReadonlyArray<Node> {
    if (this.state.kind === 'done') {
      let state = this.state
      if (state.sorting) {
        return state.sorting.indices.map(i => state.node.children[i])
      }
      else
        return state.node.children
    }
    else
      throw new Error('runtime error.')
  }

  get sorting() {
    if (this.state.kind === 'done') {
      return this.state.sorting
    }
    else
      throw new Error('runtime error.')
  }

  get selectionState(): 'none' | 'all' | 'some' {
    if (this.state.kind === 'done') {
      let state = this.state
      let len = state.selected.length
      return len === 0 ? 'none' : (len === state.node.children.length ? 'all' : 'some')
    }
    else
      throw new Error('runtime error.')
  }

  get callbacks() {
    let append = data => {
      if (this.state.kind === 'done') {
        this.state.node.children.push({
          id: data.id,
          name: data.name,
          type: data.type,
          alias: data.alias,
          class_list: data.class_list,
          children: []
        })
      }
    }
    let update = data => {
      if (this.state.kind === 'done') {
        let child = this.state.node.children.find(n => n.id === data.id)
        if (child) {
          child.name = data.name
          child.type = data.type
          child.alias = data.alias
          child.class_list = data.class_list
        }
      }
    }
    return {append, update}
  }

  created() {
    this.reset()
  }

  @Watch('$route')
  $routeChanged() {
    this.leaveSotring()
    if (this.nodeId.toString() !== this.$route.params.nodeId) {
      this.reset()
    }
  }

  beforeDestroy() {
    if (this._sortable) {
      this._sortable.destroy()
      this._sortable = undefined
    }
  }

  private async reset() {
    let nodeId  = parseInt(this.$route.params.nodeId)
    this.nodeId = nodeId
    this.busy = false
    let node = tree.find(this.root, this.nodeId)
    if (node) {
      this.state = {
        kind: 'done',
        node: node,
        selected: [],
        sorting: null
      }
    }
    else {
      this.state = { kind: 'error', message: 'Invalid node id.' }
    }
  }

  toCreate() {
    this.$router.replace({ name: 'portal-node-create' })
  }

  getUpdateLink(id: number) {
    let router = this.$router
    let route = this.$route
    let location = {
      name: 'portal-node-update',
      params: {childId: id.toString()}
    }
    return router.resolve(location, route).href
  }

  changeSelection() {
    if (this.state.kind === 'done') {
      let state = this.state
      let selected: number[] = []
      if (state.selected.length === 0) {
        for (let item of this.items)
          selected.push(item.id)
      }
      state.selected = selected
    }
  }

  async remove(event: MouseEvent, id: number) {
    if (this.state.kind !== 'done')
      return
    let state = this.state
    let app = this.$root.$children[0] as App
    let el = event.srcElement!.parentElement!.parentElement!
    if (await app.exposeAndConfirm(el, '删除操作不可恢复, 是否继续?')) {
      remoteOp(this, '删除', '节点', async () => {
        await api.node.remove(id)
        let index = state.node.children.findIndex(n=>n.id == id)
        if (index !== -1)
          state.node.children.splice(index, 1)
        index = state.selected.indexOf(id)
        if (index !== -1)
          state.selected.splice(index, 1)
      }, 880)
    }
  }

  removeSelected() {
    if (!(this.state.kind === 'done' && this.state.selected.length))
      return
    let state = this.state
    let children = state.node.children
    remoteOp(this, '删除', '节点', async () => {
      await api.node.removeArray(state.selected.map(v => ({id: v})))
      let cc = children.length
      for (let i=0; i<children.length; i++) {
        if (state.selected.indexOf(children[i].id)!==-1) {
          children.splice(i, 1)
          i--;
          if (!--cc)
            break
        }
      }
      state.selected = []
    })
  }

  get dstFilter() {
    let set = new Set<number>()
    if (this.state.kind === 'done') {
      let state = this.state
      set.add(this.nodeId)
      let recAdd = (node: Node) => {
        set.add(node.id)
        for (let child of node.children)
          recAdd(child)
      }
      for (let id of state.selected) {
        let node = state.node.children.find(n => n.id === id)
        if (node)
          recAdd(node)
      }
    }
    return (node: Node) => !set.has(node.id)
  }

  move(arg: SelectNodeResult) {
    if (!(this.state.kind === 'done' && this.state.selected.length))
      return
    let state = this.state
    remoteOp(this, '移动', '节点', async () => {
      let dstRoot = await (this.$root.$children[0] as App).getPortalRoot(arg.portal)
      let dstNode = tree.find(dstRoot, arg.nodeId)!
      await api.node.updateArray(state.selected.map(v => ({id: v, data: {parent_id: dstNode.id}})))
      let children = state.node.children
      let cc = children.length
      for (let i=0; i<children.length; i++) {
        if (state.selected.indexOf(children[i].id)!==-1) {
          let node = children.splice(i, 1)[0]
          dstNode.children.push(node)
          i--;
          if (!--cc)
            break
        }
      }
      state.selected = []
      if (arg.active) {
        this.$router.replace({
          name: 'portal-node-list',
          params: {
            portalKey: arg.portal,
            nodeId: arg.nodeId.toString(),
          }
        })
      }
    })
  }

  enterSorting() {
    if (this.state.kind !== 'done')
      return
    let state = this.state
    if (this.state.sorting)
      return
    if (state.selected.length) {
      state.selected = []
    }
    state.sorting = {
      indices: state.node.children.map((_, index) => index),
      modified: false,
      key: null,
      ast: false,
    }
    let el = this.$el.querySelector('div.wg-list')!
    this._sortable = Sortable.create(this.$el.querySelector('div.body')!, {
      animation: 120,
      onUpdate: evt => {
        if (state.sorting) {
          let s = state.sorting
          s.modified = true
          s.key = null
          s.indices.splice(evt.newIndex, 0, s.indices.splice(evt.oldIndex, 1)[0])
        }
      },
      onStart: evt => {
        el.classList.add('dragging')
      },
      onEnd: evt => {
        el.classList.remove('dragging')
      }
    })
  }

  leaveSotring() {
    if (this.state.kind !== 'done')
      return
    let state = this.state
    if (state.sorting) {
      this.$el.querySelector('div.node-list-content')!.classList.remove('list-sort')
      state.sorting = null
    }
    if (this._sortable) {
      this._sortable.destroy()
      this._sortable = undefined
    }
  }

  saveSorting() {
    if (this.state.kind !== 'done')
      return
    let state = this.state
    if (!state.sorting)
      return
    if (!state.sorting.modified) {
      if (!confirm('排序似乎未被修改, 是否继续?'))
        return
    }
    let node = state.node
    let children = state.node.children
    let indices = state.sorting.indices
    remoteOp(this, '保存', '排序', async () => {
      let list = indices.map((i, value) => {return {id: children[i].id, value} })
      await api.node.updateArray(list.map(v => ({id: v.id, data: {sort: v.value}})))
      this.leaveSotring()
      let original = children
      let newList: Node[] = []
      for (let index of indices) {
        newList.push(original[index])
      }
      node.children = newList
    })
  }

  reverse() {
    if (this.state.kind !== 'done')
      return
    if (this.state.sorting) {
      let ss = this.state.sorting
      if (ss.key) {
        this.sortBy(ss.key, !ss.ast)
      }
      else {
        ss.indices.reverse()
      }
      ss.modified = true
    }
  }

  shuffle() {
    if (this.state.kind !== 'done')
      return
    let state = this.state
    if (state.sorting) {
      state.sorting.indices = shuffle(state.sorting.indices)
      state.sorting.key = null
      state.sorting.modified = true
    }
  }

  sortBy(key: string, ast: boolean) {
    if (this.state.kind !== 'done')
      return
    if (!this.state.sorting)
      return
    let ss = this.state.sorting
    let tostr = val => val === undefined || val === null ? '' : val.toString()
    if (ss.key !== key || ss.ast !== ast) {
      ss.key = key
      ss.ast = ast
      ss.modified = true
      let compare = new Intl.Collator('en', { numeric: true }).compare
      let items = this.state.node.children
      ss.indices.sort((a, b) => {
        let aValue = items[a][key]
        let bValue = items[b][key]
        let result: number
        if (typeof aValue === 'number' && typeof bValue === 'number')
          result = aValue - bValue
        else if (typeof aValue === 'boolean' && typeof bValue === 'boolean')
          result = (aValue ? 1 : 0) - (bValue ? 1 : 0)
        else
          result = compare(tostr(aValue), tostr(bValue))
        return ast ? result : -result;
      })
    }
  }
}
